module.exports = __webpack_public_path__ + "static/media/googleplay.e61d40cd.png";